module.exports = __webpack_public_path__ + "img/resto-world-gif.b5b4eb49.gif";